const grecaptcha = window.grecaptcha;

jQuery(function ($) {
  var language = $("html").attr("lang");

  var datePickerLanguage = language.split("-");
  console.log(datePickerLanguage);
  datePickerLanguage = datePickerLanguage[0].toLowerCase();

  var recaptchaPublicKey = $("meta[name=recaptcha_public]").attr("content");

  var $userLoginForm = $("#login_form");
  var $userLogoutForm = $("#logout_form");
  var $subscribeForm = $("#subscribe_form");
  var $forgotPasswordForm = $("#forgot_password_form");
  var $resetPasswordForm = $("#reset_password_form");
  var $activeMemberForm = $("#active_member_form");
  var $updateProfileForm = $("#profil_form");
  var $userDeleteProfilForm = $("#deleteprofil_form");
  // Sélectionnez toutes les cases à cocher des compétences
  var skillCheckboxes = $('[name^="user_skills[]"]');

  // Sélectionnez la case à cocher "Je suis maker"
  var makerCheckbox = $("#maker");

  skillCheckboxes.on("change", function () {
    // Vérifiez si au moins une case à cocher des compétences est cochée
    var atLeastOneSkillChecked = skillCheckboxes.is(":checked");

    // Mettez à jour la case à cocher "Je suis maker" en fonction du résultat ci-dessus
    makerCheckbox.prop("checked", atLeastOneSkillChecked);

    // Empêchez la case à cocher "Je suis maker" d'être décochée si au moins une compétence est cochée
  });
  makerCheckbox.on("change", function () {
    var atLeastOneSkillChecked = skillCheckboxes.is(":checked");
    if (atLeastOneSkillChecked == true)
      makerCheckbox.prop("checked", atLeastOneSkillChecked);
  });

  $(".btn-validate-maker").on("click", function (e) {
    e.preventDefault();
    var i = $(this),
      s = i.html(),
      n = [],
      o = i.data("target");
    n.push({ name: "action", value: "validate_maker" }),
      n.push({ name: "userID", value: i.data("user-id") }),
      i
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin"></i>'),
      $.post(o, n)
        .always(function () {
          i.removeAttr("disabled").html(s);
        })
        .done(function () {
          i.html("OK").attr("disabled", "disabled"),
            setTimeout(function () {
              i.fadeOut();
            }, 2e3);
        })
        .fail(function () {
          i.html("Error").removeClass("btn-green").addClass("btn-danger");
        });
  });

  $(".btn-request-reactivation").on("click", function (e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.is("[disabled]")) {
      return;
    }

    var originalHtml = $btn.data("original-label");
    if (!originalHtml) {
      originalHtml = $btn.html();
      $btn.data("original-label", originalHtml);
    }

    var $feedback = $btn
      .closest(".maker-reactivation-alert")
      .find(".maker-reactivation-feedback");
    var endpoint = $btn.data("target");
    var nonce = $btn.data("nonce");
    var defaultError = $btn.data("error") || "";
    var defaultSuccess = $btn.data("success") || "";

    $feedback.removeClass("text-danger text-success").text("");
    $btn
      .attr("disabled", "disabled")
      .html('<i class="fa fa-circle-notch fa-spin"></i>');

    $.post(endpoint, {
      action: "enable_request_maker_reactivation",
      nonce: nonce,
    })
      .done(function (response) {
        var successMessage = defaultSuccess;
        if (response && response.data && response.data.message) {
          successMessage = response.data.message;
        }
        if (successMessage) {
          $feedback
            .removeClass("text-danger")
            .addClass("text-success")
            .text(successMessage);
        }
        $btn.html('<i class="fa fa-check"></i>');
      })
      .fail(function (xhr) {
        var errorMessage = defaultError;
        if (
          xhr.responseJSON &&
          xhr.responseJSON.data &&
          xhr.responseJSON.data.message
        ) {
          errorMessage = xhr.responseJSON.data.message;
        }
        $feedback
          .removeClass("text-success")
          .addClass("text-danger")
          .text(errorMessage);
        $btn.removeAttr("disabled").html(originalHtml);
      });
  });
  // Display Modal reset password is needed
  if ($("#resetPasswordModal").length > 0) {
    $("#resetPasswordModal").modal("show");
  }

  $(".forgot-password-link").click(function (e) {
    e.preventDefault();

    $(".modal").modal("hide");
    setTimeout(function () {
      $("#forgotPasswordModal").modal("show");
    }, 550);
  });

  $("#birthday").datepicker({
    showRightIcon: false,
    format: "dd/mm/yyyy",
    language: datePickerLanguage,
    endDate: "-18y",
  });

  $("#dest_birthdate").datepicker({
    showRightIcon: false,
    format: "dd/mm/yyyy",
    language: datePickerLanguage,
    // endDate: '-18y',
  });

  if ($userLoginForm.length > 0) {
    var userLoginformValidator = $userLoginForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
    });

    $userLoginForm.on("submit", function (e) {
      e.preventDefault();

      var $this = $(this);
      var target = $this.attr("action");
      var formData = $this.serializeArray();
      var $submitButton = $this.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $this.find(".alert.alert-danger").fadeOut();

      if (!userLoginformValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin fa-fw"></i>');

      formData.push({
        name: "action",
        value: "ajaxlogin",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "contact" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              $("#userLoginModal").modal("hide");
              setTimeout(function () {
                $("#userLoginSuccessModal").modal("show");
              }, 550);
            })
            .fail(function () {
              $this.find(".alert.alert-danger").fadeIn();
            });
        });
    });
  }

  if ($userLogoutForm.length > 0) {
    var userLogoutformValidator = $userLogoutForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
    });

    $userLogoutForm.on("submit", function (e) {
      e.preventDefault();

      var $this = $(this);
      var target = $this.attr("action");
      var formData = $this.serializeArray();
      var $submitButton = $this.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $this.find(".alert.alert-danger").fadeOut();

      if (!userLogoutformValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin fa-fw"></i>');

      formData.push({
        name: "action",
        value: "ajaxlogout",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "contact" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              $("#userLogoutModal").modal("hide");
              setTimeout(function () {
                $("#userLogoutSuccessModal").modal("show");
              }, 550);
            })
            .fail(function () {
              $this.find(".alert.alert-danger").fadeIn();
            });
        });
    });
  }

  if ($userDeleteProfilForm.length > 0) {
    var userDeleteProfilFormValidator = $userDeleteProfilForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
    });

    $userDeleteProfilForm.on("submit", function (e) {
      e.preventDefault();

      var $this = $(this);
      var target = $this.attr("action");
      var formData = $this.serializeArray();
      var $submitButton = $this.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $this.find(".alert.alert-danger").fadeOut();

      if (!userDeleteProfilFormValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin fa-fw"></i>');

      formData.push({
        name: "action",
        value: "ajaxdeleteprofil",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "deleteprofil" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              $("#deleteProfilModal").modal("hide");
              setTimeout(function () {
                $("#deleteProfilSuccessModal").modal("show");
              }, 550);
            })
            .fail(function () {
              $this.find(".alert.alert-danger").fadeIn();
            });
        });
    });
  }

  $.validator.addMethod(
    "requireOneChecked",
    function () {
      var needDeviceChecked = $("#need-device").is(":checked");
      var makerChecked = $("#maker").is(":checked");
      if (needDeviceChecked || makerChecked) {
        $("#need_device-error, #maker-error").hide();
      } else {
        $("#need_device-error, #maker-error").show(); // Affiche le message d'erreur
      }
      return needDeviceChecked || makerChecked;
    },
    "Veuillez cocher au moins l'une des options."
  );

  if ($subscribeForm.length > 0) {
    var subscribeFormValidator = $subscribeForm.validate({
      // debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      invalidHandler: function (form, validator) {
        if (!validator.numberOfInvalids()) return;

        $("html, body").animate(
          {
            scrollTop: $(validator.errorList[0].element).offset().top - 40,
          },
          1000
        );
      },
      rules: {
        phone: {
          required: function () {
            return !$("#mobile_phone").val();
          },
        },
        mobile_phone: {
          required: function () {
            return !$("#phone").val();
          },
        },
        need_device: {
          requireOneChecked: true,
        },
        maker: {
          requireOneChecked: true,
        },
      },
    });

    $subscribeForm.on("submit", function (e) {
      e.preventDefault();

      var $this = $(this);
      var target = $this.attr("action");
      var formData = $this.serializeArray();
      var $submitButton = $this.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $this.find(".alert.alert-danger").fadeOut();

      if (!subscribeFormValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin fa-fw"></i>');

      formData.push({
        name: "action",
        value: "ajaxsubscribe",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "subscribe" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              $this.fadeOut();
              $("#userRegisterSuccessModal").modal("show");
            })
            .fail(function (response) {
              var $alert = $subscribeForm.find(
                ".alert.alert-danger[data-error-id=" +
                  response.responseJSON.data.error_id +
                  "]"
              );

              if ($alert.length <= 0) {
                $alert = $subscribeForm.find(
                  ".alert.alert-danger[data-error-id=none]"
                );
              }

              if ($alert.length > 0) {
                $alert.fadeIn(function () {
                  $("html, body").animate(
                    {
                      scrollTop: $alert.offset().top - 30,
                    },
                    500
                  );
                });
              }
            });
        });
    });
  }

  // Forgot Password Form
  if ($forgotPasswordForm.length > 0) {
    var forgotPasswordformValidator = $forgotPasswordForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else if (element.attr("type") == "radio") {
          element.parents(".form-group").append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      rules: {
        //
      },
    });

    $forgotPasswordForm.on("submit", function (e) {
      e.preventDefault();

      var $myForm = $(this);
      var target = $myForm.attr("action");
      // var formData = $myForm.serializeArray();
      var $submitButton = $myForm.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $myForm.find(".alert").fadeOut();

      if (!forgotPasswordformValidator.valid()) {
        // Check if form is valid
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin"></i>');

      var formData = [
        {
          name: "user_login",
          value: $myForm.find("#forgot_email").val(),
        },
      ];

      grecaptcha
        .execute(recaptchaPublicKey, { action: "contact" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function (result) {
              var $html = $("<div>" + result + "</div>");
              var $error = $html.find("#login #login_error");

              // Transform body into html hack
              var data = result
                .replace("<body", "<container")
                .replace("body>", "container>");
              var body = $(data).filter("container");

              var $success = body.hasClass("login-action-checkemail");

              if ($error.length > 0) {
                $myForm
                  .find(".alert.alert-danger")
                  .html($error.html())
                  .fadeIn();
                return false;
              }

              if ($success) {
                var $alert = $myForm.parent().find(".alert.alert-success");
                $myForm.fadeOut(function () {
                  $alert.fadeIn();
                });
              }
            })
            .fail(function () {});
        });
    });
  }

  // Reset Password Form
  if ($resetPasswordForm.length > 0) {
    var resetPasswordformValidator = $resetPasswordForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else if (element.attr("type") == "radio") {
          element.parents(".form-group").append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      rules: {
        //
      },
    });

    $resetPasswordForm.on("submit", function (e) {
      e.preventDefault();

      var $myForm = $(this);
      var target = $myForm.attr("action");
      var formData = $myForm.serializeArray();
      var $submitButton = $myForm.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $myForm.find(".alert").fadeOut();

      if (!resetPasswordformValidator.valid()) {
        // Check if form is valid
        console.log("form error");
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin"></i>');

      formData.push({
        name: "action",
        value: "ajaxresetpassword",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "contact" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              $myForm.fadeOut(function () {
                $myForm.parent().find(".alert-success").fadeIn();
              });
            })
            .fail(function (response) {
              var $alert = $myForm.find(
                ".alert.alert-danger[data-error-id=" +
                  response.responseJSON.data.error_id +
                  "]"
              );

              if ($alert.length <= 0) {
                $alert = $myForm.find(
                  ".alert.alert-danger[data-error-id=none]"
                );
              }

              if ($alert.length > 0) {
                $alert.fadeIn();
                $(".modal.show .modal-body").animate({
                  scrollTop: $alert.position().top,
                });
              }
            });
        });
    });
  }

  // Active Member Form
  if ($activeMemberForm.length > 0) {
    var activeMemberFormValidator = $activeMemberForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else if (element.attr("type") == "radio") {
          element.parents(".form-group").append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      rules: {
        //
      },
    });

    $activeMemberForm.on("submit", function (e) {
      e.preventDefault();

      var $myForm = $(this);
      var target = $myForm.attr("action");
      var formData = $myForm.serializeArray();
      var $submitButton = $myForm.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $myForm.find(".alert").fadeOut();

      if (!activeMemberFormValidator.valid()) {
        // Check if form is valid
        console.log("form error");
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin"></i>');

      formData.push({
        name: "action",
        value: "ajaxsendactivemember",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "contact" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              var $alert = $myForm.parent().find(".alert-success");
              $myForm.fadeOut(function () {
                $alert.fadeIn();
                $("html, body").animate({
                  scrollTop: $alert.offset().top - 30,
                });
              });
            })
            .fail(function (response) {
              var $alert = $myForm.find(
                ".alert.alert-danger[data-error-id=" +
                  response.responseJSON.data.error_id +
                  "]"
              );

              if ($alert.length <= 0) {
                $alert = $myForm.find(
                  ".alert.alert-danger[data-error-id=none]"
                );
              }

              if ($alert.length > 0) {
                $alert.fadeIn();
                $("html, body").animate({
                  scrollTop: $alert.offset().top - 30,
                });
              }
            });
        });
    });
  }

  // Update Profile Form
  if ($updateProfileForm.length > 0) {
    var updateProfileFormValidator = $updateProfileForm.validate({
      debug: true,
      showErrors: function () {
        this.defaultShowErrors();
      },
      errorPlacement: function (label, element) {
        if (element.attr("type") == "checkbox") {
          element.parent().append(label);
        } else if (element.attr("type") == "radio") {
          element.parents(".form-group").append(label);
        } else {
          label.insertAfter(element);
        }
      },
      messages: {
        //
      },
      rules: {
        phone: {
          required: function () {
            return !$("#mobile_phone").val();
          },
        },
        mobile_phone: {
          required: function () {
            return !$("#phone").val();
          },
        },
      },
    });

    $updateProfileForm.on("submit", function (e) {
      e.preventDefault();

      var $myForm = $(this);
      var target = $myForm.attr("action");
      var formData = $myForm.serializeArray();
      var $submitButton = $myForm.find("button[type=submit]");
      var submitButtonHtml = $submitButton.html();

      $myForm.find(".alert").fadeOut();

      if (!updateProfileFormValidator.valid()) {
        // Check if form is valid
        console.log("form error");
        return false;
      }

      $submitButton
        .attr("disabled", "disabled")
        .html('<i class="fas fa-circle-notch fa-spin"></i>');

      formData.push({
        name: "action",
        value: "ajaxupdateprofile",
      });

      grecaptcha
        .execute(recaptchaPublicKey, { action: "updateprofile" })
        .then(function (token) {
          formData.push({
            name: "recaptchaToken",
            value: token,
          });

          $.post(target, formData)
            .always(function () {
              $submitButton.removeAttr("disabled").html(submitButtonHtml);
            })
            .done(function () {
              $("#userProfileSuccessModal").modal("show");
            })
            .fail(function (response) {
              var $alert = $myForm.find(
                ".alert.alert-danger[data-error-id=" +
                  response.responseJSON.data.error_id +
                  "]"
              );

              if ($alert.length <= 0) {
                $alert = $myForm.find(
                  ".alert.alert-danger[data-error-id=none]"
                );
              }

              if ($alert.length > 0) {
                $alert.fadeIn();
                $("html, body").animate({
                  scrollTop: $alert.offset().top - 30,
                });
              }
            });
        });
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/autoload/_user_forms.js